/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */
import _Vue from 'vue';
import { TrackingPlugin } from '../tracking';

export class AssetPlugin {
  /**
     * returns the header logo of the cdn
     * @param gameKey
     */
  header(gameKey: string): string {
    return `${process.env.VUE_APP_CDN_URL}/${process.env.VUE_APP_CDN_PATTERN_HEADER.replace('%s', gameKey)}`;
  }

  /**
     * returns the payment method logo from the cdn
     *
     * @param method
     * @param modern
     */
  methodLogo(method: string, modern = true): string {
    const map = {
      '{method}': method,
      '{extension}': modern ? 'svg' : 'png',
    };

    return `${process.env.VUE_APP_CDN_URL}/${process.env.VUE_APP_CDN_PATTERN_METHOD
      .replace(/{method}|{extension}/gi, (matched) => map[matched])}`;
  }

  /**
     * returns the cdn url of the product header
     *
     * @param productKey
     * @param breakpoint
     * @param modern
     */
  productHeader(productKey: string, breakpoint: string, modern = true): string {
    const map = {
      '{productKey}': productKey,
      '{breakpoint}': breakpoint,
      '{extension}': modern ? 'webp' : 'jpg',
    };

    return `${process.env.VUE_APP_CDN_URL}/${process.env.VUE_APP_CDN_PATTERN_COVER_MODERN
      .replace(/{productKey}|{breakpoint}|{extension}/gi, (matched) => map[matched])}`;
  }

  /**
     * returns the game cover logo of the cdn
     * @param gameKey
     */
  gameCover(gameKey: string): string {
    return `${process.env.VUE_APP_CDN_URL}/${process.env.VUE_APP_CDN_PATTERN_COVER.replace('%s', gameKey)}`;
  }

  /**
     * returns the game logo of the cdn
     * @param gameKey
     */
  gameLogo(gameKey: string): string {
    return `${process.env.VUE_APP_CDN_URL}/${process.env.VUE_APP_CDN_PATTERN_LOGO.replace('%s', gameKey)}`;
  }

  /**
   * icons for the minecraft modpacks
   * @param icon
   */
  modpackIcon(icon: string) : string {
    return `${process.env.VUE_APP_CDN_URL}/${process.env.VUE_APP_CDN_PATTERN_MODPACK.replace('%s', icon)}`;
  }

  /**
   * icons for the extension
   * @param icon
   */
  extensionIcon(icon: string): string {
    return `${process.env.VUE_APP_CDN_URL}/${process.env.VUE_APP_CDN_PATTERN_EXTENSION.replace('%s', icon)}`;
  }

  get gameLogoWidth(): number {
    return Number(process.env.VUE_APP_CDN_LOGO_WIDTH);
  }

  get gameLogoHeight(): number {
    return Number(process.env.VUE_APP_CDN_LOGO_WIDTH);
  }

  image(path: string): string {
    return `${process.env.VUE_APP_CDN_URL}/${path}`;
  }
}

export function VueAssetPlugin(Vue: typeof _Vue, options?): void {
  Vue.prototype.$asset = new AssetPlugin();
}

// ### Composition API Usage ###
export const asset = new AssetPlugin();
export const useAsset = (): AssetPlugin => asset;
